var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},_vm._l((_vm.props.layout.rows),function(row,index){return _c('v-row',{key:index},_vm._l((row),function(col,index){return _c('v-col',{key:index,attrs:{"cols":col.cols}},[_c('div',[_c('span',{staticClass:"data-inline-data-title"},[_vm._v("\n          "+_vm._s(col.label)+"\n        ")]),_c('div',{class:col.class
              ? col.class
              : ['data-inline-data', 'text-justify']},[_c('Field',{attrs:{"field":_vm.current_qunit[col.id]}})],1)])])}),1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }